<script lang="ts">
	import Icon from '../elements/Icon.svelte';
	import type { PaginationInfo } from '../types/Pagination';
	import { t } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';

	export let data: PaginationInfo;

	const dispatch = createEventDispatcher();

	const dispatchChange = () => {
		dispatch('load', {
			number: data.number
		});
	};

	const gotoPage = (i: number) => {
		if (i >= 0 && i < data.totalPages && i !== data.number) {
			data = {
				...data,
				number: i
			};
			dispatchChange();
		}
	};

	const gotoFirstPage = () => {
		gotoPage(0);
	};

	const gotoPrevPage = () => {
		gotoPage(data.number - 1);
	};

	const gotoNextPage = () => {
		gotoPage(data.number + 1);
	};

	const gotoLastPage = () => {
		gotoPage(data.totalPages - 1);
	};
</script>

{#if data}
	<div
		class="flex flex-wrap justify-center sm:justify-between items-center
    py-5 md:py-6 space-y-2 sm:space-y-0"
	>
		<span>
			{$t('pagination.summary', {
				values: {
					number: data.number + 1,
					totalPages: data.totalPages,
					totalElements: data.totalElements
				}
			})}
		</span>
		<div class="pages">
			<span class="pages-item" on:click={() => gotoFirstPage()}>
				<Icon name="skip_previous" />
			</span>
			<span class="pages-item" on:click={() => gotoPrevPage()}>
				<Icon name="keyboard_arrow_left" />
			</span>

			{#if data.number === data.totalPages - 1 && data.totalPages > 2}
				<span class="pages-item" on:click={() => gotoPage(data.number - 2)}>
					{data.number - 1}
				</span>
			{/if}
			{#if data.number > 0}
				<span class="pages-item" on:click={() => gotoPage(data.number - 1)}>
					{data.number}
				</span>
			{/if}
			<span class="pages-item is-current-page" on:click={() => gotoPage(data.number)}>
				{data.number + 1}
			</span>
			{#if data.number < data.totalPages - 1}
				<span class="pages-item" on:click={() => gotoPage(data.number + 1)}>
					{data.number + 2}
				</span>
			{/if}
			{#if data.number === 0 && data.totalPages > 2}
				<span class="pages-item" on:click={() => gotoPage(data.number + 2)}>
					{data.number + 3}
				</span>
			{/if}

			<span class="pages-item" on:click={() => gotoNextPage()}>
				<Icon classNames="transform rotate-180" name="keyboard_arrow_left" />
			</span>
			<span class="pages-item" on:click={() => gotoLastPage()}>
				<Icon name="skip_next" />
			</span>
		</div>
	</div>
{/if}

<style lang="postcss">
	.pages {
		@apply flex justify-center items-center rounded-md shadow select-none;
	}

	.pages > .pages-item {
		@apply cursor-pointer hover:shadow-lg hover:bg-grey-lighter
    inline-flex items-center justify-center
    p-2 w-5 h-5 md:w-6 md:h-6
    text-sm font-bold
    border-t border-r border-b border-grey-lighter;

		&:first-child {
			@apply border-l rounded-tl-md rounded-bl-md;
		}

		&:last-child {
			@apply rounded-tr-md rounded-br-md;
		}
	}

	.pages > .pages-item.is-current-page {
		@apply bg-primary text-white border-primary;
	}
</style>
